export default function useTitleTagMapping() {
    const { t } = useI18n();

    const getTitleTag = (shopName: string) => {
        const currentUrl = useRequestURL();
        const path = currentUrl.pathname;

        if (path.includes('account/order/edit')) {
            return t('titleMapping.account.order.edit', { shopName: shopName });
        }

        if (path.includes('account/recover')) {
            return t('titleMapping.account.recover', { shopName: shopName });
        }

        if (path.includes('account/address')) {
            return t('titleMapping.account.address', { shopName: shopName });
        }

        if (path.includes('account/login')) {
            return t('titleMapping.account.login', { shopName: shopName });
        }

        if (path.includes('account/orders')) {
            return t('titleMapping.account.orders', { shopName: shopName });
        }

        if (path.includes('account/payment')) {
            return t('titleMapping.account.payment', { shopName: shopName });
        }

        if (path.includes('account/profile')) {
            return t('titleMapping.account.profile', { shopName: shopName });
        }

        if (path.includes('account/register')) {
            return t('titleMapping.account.register', { shopName: shopName });
        }

        if (path.includes('account')) {
            return t('titleMapping.account.overview', { shopName: shopName });
        }

        if (path.includes('checkout/finish')) {
            return t('titleMapping.checkout.finish', { shopName: shopName });
        }

        if (path.includes('checkout/authentication')) {
            return t('titleMapping.checkout.authentication', { shopName: shopName });
        }

        if (path.includes('checkout/confirm')) {
            return t('titleMapping.checkout.confirm', { shopName: shopName });
        }

        if (path.includes('checkout/cart')) {
            return t('titleMapping.checkout.cart', { shopName: shopName });
        }

        if (path.includes('newsletter/confirm')) {
            return t('titleMapping.newsletter.confirm', { shopName: shopName });
        }

        if (path.includes('search')) {
            const urlParams = new URLSearchParams(currentUrl.search);
            const searchTerm = urlParams.get('search') || '';
            return t('titleMapping.search', {  shopName: shopName, searchTerm });
        }

        if (path.includes('wishlist')) {
            return t('titleMapping.wishlist', { shopName: shopName });
        }

        return shopName;
    }

    return {
        getTitleTag,
    }
}
